export default __webpack_public_path__ + "assets/img/mts.90e1028.svg";